"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8105],{

/***/ 19487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6115);


/***/ }),

/***/ 19777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _gaBoolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20914);



var buildClickCommonEvent = function buildClickCommonEvent(data) {
  var _data$shipping, _data$shipping$, _data$shipping$$packa, _data$category, _data$seller, _data$seller2, _data$seller3, _data$subcategory, _data$seller4, _data$price;
  var withFreight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var shippingPackage = (data == null ? void 0 : (_data$shipping = data.shipping) == null ? void 0 : (_data$shipping$ = _data$shipping[0]) == null ? void 0 : (_data$shipping$$packa = _data$shipping$.packages) == null ? void 0 : _data$shipping$$packa[0]) || {};
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    categorias: data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id,
    categoriaSeller: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    event: 'clickEvent',
    nomeSeller: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    produtoClube: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])((_data$seller3 = data.seller) == null ? void 0 : _data$seller3.discounts),
    produtoDisponivel: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])(data == null ? void 0 : data.available),
    produtoFavoritado: (data == null ? void 0 : data.accountId) ? (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])(data == null ? void 0 : data.isOnWishlist) : undefined,
    sku: data == null ? void 0 : data.id,
    subcategorias: data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id
  }, withFreight && {
    freteTotal: shippingPackage == null ? void 0 : shippingPackage.price
  }, withFreight && {
    valorFrete: shippingPackage == null ? void 0 : shippingPackage.price
  }, withFreight && {
    sellerEntrega: data == null ? void 0 : (_data$seller4 = data.seller) == null ? void 0 : _data$seller4.deliveryId
  }, withFreight && {
    retiraLoja: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .hasPickupStore */ .V9)(shippingPackage == null ? void 0 : shippingPackage.deliveryTypes))
  }, {
    value: (data == null ? void 0 : data.price) ? parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) : undefined
  });
};
/* harmony default export */ __webpack_exports__["default"] = (buildClickCommonEvent);

/***/ }),

/***/ 98011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var categoryToString = function categoryToString(category, subcategory) {
  if (!category || !subcategory) {
    return undefined;
  }
  return "".concat(category, "/").concat(subcategory);
};
/* harmony default export */ __webpack_exports__["default"] = (categoryToString);

/***/ }),

/***/ 27903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var channelStoreDimensions = function channelStoreDimensions(channel) {
  var _channel$data;
  var store = channel == null ? void 0 : (_channel$data = channel.data) == null ? void 0 : _channel$data.find(function (item) {
    return item.name === 'store';
  });
  var hasStore = !!(store == null ? void 0 : store.value);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, hasStore ? {
    idDaLoja: store.value.id,
    nomeDaLoja: store.value.name
  } : {});
};
/* harmony default export */ __webpack_exports__["default"] = (channelStoreDimensions);

/***/ }),

/***/ 24169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _GA4_utils_dataLayerPushQueue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60604);



var dataLayerPush = function dataLayerPush(listener) {
  return function () {
    var _structure$config;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _ref = args[args.length - 1] || {},
      config = _ref.config,
      structure = _ref.structure;
    var isDevelopment = (config == null ? void 0 : config.environment) === 'development';
    if (!listener || _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .whereAmI.onServer */ .er.onServer || !window.dataLayer || !document) return;
    var data = listener.apply(void 0, args);
    if (!data) {
      if (isDevelopment) {
        console.warn('[dataLayer.push]: ocorreu uma tentativa de envio de evento sem dados', args);
      }
      return;
    }
    var finalData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, {
      hitTimestamp: new Date().getTime()
    });
    if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
      (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .useFirebasePush */ .Gz)(finalData);
    } else {
      (0,_GA4_utils_dataLayerPushQueue__WEBPACK_IMPORTED_MODULE_2__.dataLayerPushWithQueue)(finalData);
    }
    if (isDevelopment) {
      var listnerResult = listener.apply(void 0, args);
      if (listnerResult) {
        var event = listnerResult.event,
          eventCategory = listnerResult.eventCategory,
          pageType = listnerResult.pageType,
          contentType = listnerResult.content_type;
        var title = "%c[ga log] ".concat(eventCategory || pageType || contentType, " ").concat(event, "\n");
        console.groupCollapsed(title, 'color: #03A9F4');
        console.log("\uD83D\uDCE1 [dataLayer.push]", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, listener.apply(void 0, args)));
        console.groupEnd(title);
      }
    }
  };
};
/* harmony default export */ __webpack_exports__["default"] = (dataLayerPush);

/***/ }),

/***/ 53004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ga4ParseDimensions": function() { return /* binding */ ga4ParseDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var ga4ParseDimensions = function ga4ParseDimensions(data) {
  var _data$shippingError, _data$seller, _data$seller$details, _data$seller$details$, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$offerTags, _data$badges, _data$badges$, _data$geoLocTags, _data$query;
  var reason = (data == null ? void 0 : (_data$shippingError = data.shippingError) == null ? void 0 : _data$shippingError.includes('Estoque')) ? 'sem-estoque' : 'cep-indisponivel';
  return {
    dimension5: data.seller.category,
    dimension7: undefined,
    dimension11: data.shippingError ? "falso:".concat(reason) : 'verdadeiro',
    dimension23: data.seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[data.seller.id] ? undefined : "".concat(Number(!!(data == null ? void 0 : data.togglePdpSellerScore)), ":").concat((data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : (_data$seller$details = _data$seller.details) == null ? void 0 : (_data$seller$details$ = _data$seller$details.score) == null ? void 0 : _data$seller$details$.toString()) || null),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString(), "|av:").concat(data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()),
    dimension41: "etiqueta:".concat((data == null ? void 0 : (_data$offerTags = data.offerTags) == null ? void 0 : _data$offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0'),
    dimension61: data.seller.id,
    dimension62: data.seller.deliveryId || undefined,
    dimension86: "selo:".concat((data == null ? void 0 : (_data$badges = data.badges) == null ? void 0 : (_data$badges$ = _data$badges[0]) == null ? void 0 : _data$badges$.text) || 'sem-selo', "|tags:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$geoLocTags = data.geoLocTags) == null ? void 0 : _data$geoLocTags.title) || 'sem-tag'),
    dimension103: (data == null ? void 0 : (_data$query = data.query) == null ? void 0 : _data$query.chatbot_lu) ? 'chatbot-lu' : undefined,
    dimension104: undefined,
    dimension112: undefined,
    dimension115: undefined
  };
};

/***/ }),

/***/ 20914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var gaBoolean = function gaBoolean(data) {
  if (data === undefined) return undefined;
  return data && (!Array.isArray(data) || data.length) ? 'verdadeiro' : 'falso';
};
/* harmony default export */ __webpack_exports__["default"] = (gaBoolean);

/***/ }),

/***/ 15950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59740);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _events_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59075);
/* harmony import */ var _categoryToString__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98011);
/* harmony import */ var _gaBoolean__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20914);

var _excluded = ["accountId", "id", "variationId", "title"];




var gaEcommerceProduct = function gaEcommerceProduct() {
  var _data$brand, _data$category, _data$subcategory, _data$installment, _data$seller, _data$seller2, _data$attributes, _data$attributes2, _data$attributes2$, _data$shippingValues, _data$shippingValues2, _data$shippingValues3, _data$shippingValues4, _data$shippingValues5, _data$offerTags, _data$overview, _data$overview2, _data$financialServic, _data$financialServic2, _data$financialServic3, _data$seller3, _data$overview3, _data$overview4, _data$rating, _data$rating$score, _data$price, _data$price2, _data$overview5, _data$installment2, _data$installment2$qu, _data$rating2, _data$rating2$count, _data$badges, _data$badges$, _data$geoLocTags, _data$query, _data$price3, _data$price4;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var accountId = _ref.accountId,
    id = _ref.id,
    variationId = _ref.variationId,
    name = _ref.title,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  return {
    brand: (data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || undefined,
    category: (0,_categoryToString__WEBPACK_IMPORTED_MODULE_3__["default"])(data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id, data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id),
    currency: _events_constants__WEBPACK_IMPORTED_MODULE_1__.CURRENCY,
    dimension12: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.available),
    dimension13: accountId ? (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.isOnWishlist) : undefined,
    dimension14: 'falso',
    dimension15: data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount,
    dimension16: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    dimension17: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    dimension18: (data == null ? void 0 : (_data$attributes = data.attributes) == null ? void 0 : _data$attributes.length) ? data == null ? void 0 : (_data$attributes2 = data.attributes) == null ? void 0 : (_data$attributes2$ = _data$attributes2[0]) == null ? void 0 : _data$attributes2$.value : undefined,
    dimension19: data == null ? void 0 : data.term,
    dimension20: data == null ? void 0 : (_data$shippingValues = data.shippingValues) == null ? void 0 : _data$shippingValues.store_pickup,
    dimension21: data == null ? void 0 : (_data$shippingValues2 = data.shippingValues) == null ? void 0 : _data$shippingValues2.default_ship,
    dimension22: data == null ? void 0 : (_data$shippingValues3 = data.shippingValues) == null ? void 0 : _data$shippingValues3.shipping_value,
    dimension23: data == null ? void 0 : (_data$shippingValues4 = data.shippingValues) == null ? void 0 : _data$shippingValues4.days,
    dimension24: data == null ? void 0 : (_data$shippingValues5 = data.shippingValues) == null ? void 0 : _data$shippingValues5.days_pickup,
    dimension41: "etiqueta:".concat((data == null ? void 0 : (_data$offerTags = data.offerTags) == null ? void 0 : _data$offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0'),
    dimension44: data == null ? void 0 : (_data$overview = data.overview) == null ? void 0 : _data$overview.warranty,
    dimension45: data == null ? void 0 : (_data$overview2 = data.overview) == null ? void 0 : _data$overview2.theft,
    dimension46: (data == null ? void 0 : (_data$financialServic = data.financialServices) == null ? void 0 : (_data$financialServic2 = _data$financialServic.filter(function (item) {
      return item.description === 'Troca Certa';
    })[0]) == null ? void 0 : (_data$financialServic3 = _data$financialServic2.offers) == null ? void 0 : _data$financialServic3.reduce(function (ac, item) {
      return ac + (ac === '' ? item.treeId : " | ".concat(item.treeId));
    }, '')) || 'none',
    dimension57: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.isBuyBox),
    dimension58: undefined,
    dimension62: data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.deliveryId,
    dimension66: data == null ? void 0 : (_data$overview3 = data.overview) == null ? void 0 : _data$overview3.images,
    dimension67: data == null ? void 0 : (_data$overview4 = data.overview) == null ? void 0 : _data$overview4.media,
    dimension68: data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$score = _data$rating.score) == null ? void 0 : _data$rating$score.toString(),
    dimension70: data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.price,
    dimension71: undefined,
    dimension72: data.location,
    dimension76: data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice,
    dimension77: data == null ? void 0 : (_data$overview5 = data.overview) == null ? void 0 : _data$overview5.discountPercenter,
    dimension78: data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : (_data$installment2$qu = _data$installment2.quantity) == null ? void 0 : _data$installment2$qu.toString(),
    dimension79: data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$count = _data$rating2.count) == null ? void 0 : _data$rating2$count.toString(),
    dimension85: undefined,
    dimension86: "selo:".concat((data == null ? void 0 : (_data$badges = data.badges) == null ? void 0 : (_data$badges$ = _data$badges[0]) == null ? void 0 : _data$badges$.text) || 'sem-selo', "|tags:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$geoLocTags = data.geoLocTags) == null ? void 0 : _data$geoLocTags.title) || 'sem-tag'),
    dimension87: undefined,
    dimension103: (data == null ? void 0 : (_data$query = data.query) == null ? void 0 : _data$query.chatbot_lu) ? 'chatbot-lu' : undefined,
    id: id,
    name: name,
    price: Math.round((data == null ? void 0 : (_data$price3 = data.price) == null ? void 0 : _data$price3.bestPrice) * 1e2) / 1e2 || Math.round((data == null ? void 0 : (_data$price4 = data.price) == null ? void 0 : _data$price4.price) * 1e2) / 1e2 || undefined,
    quantity: 1,
    variant: variationId
  };
};
/* harmony default export */ __webpack_exports__["default"] = (gaEcommerceProduct);

/***/ }),

/***/ 66724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var gaSelectedFilters = function gaSelectedFilters(filters) {
  return filters && Array.isArray(filters) && filters.length ? filters.map(function (f) {
    return f.value;
  }).filter(Boolean).join('|') || undefined : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (gaSelectedFilters);

/***/ }),

/***/ 82115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getBestPriceDiscount = function getBestPriceDiscount(data) {
  var _data$price, _data$price2;
  return (data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.bestPrice) && Boolean(Number(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.discount)) ? data.price.bestPrice : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (getBestPriceDiscount);

/***/ }),

/***/ 54730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getDiscount = function getDiscount(data) {
  var _data$price, _data$price2;
  return Number(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.discount) ? "".concat(Number(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.discount), "%") : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (getDiscount);

/***/ }),

/***/ 50734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getInstallmentQuantity = function getInstallmentQuantity(data) {
  var _data$installment, _data$installment2;
  return (data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.quantity) ? "parcelas-".concat(data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (getInstallmentQuantity);

/***/ }),

/***/ 6983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getSearchTerm = function getSearchTerm(pageId) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var route = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var pages = {
    brand: route == null ? void 0 : route.brandId,
    category: route == null ? void 0 : route.categorySlug,
    search: route == null ? void 0 : route.term,
    selection: route == null ? void 0 : route.selectionId,
    seller: route == null ? void 0 : route.sellerId,
    subcategory: route == null ? void 0 : route.slug1
  };
  return (data == null ? void 0 : data.type) || pages[pageId];
};
/* harmony default export */ __webpack_exports__["default"] = (getSearchTerm);

/***/ }),

/***/ 22078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var typesButton = {
  addToBag: 'adicionar-a-sacola',
  oneTouch: 'comprar-agora',
  pickupStore: 'retira-loja',
  typeFloat: 'botao-flutuante'
};
var getTypeButton = function getTypeButton(typeButton) {
  return typesButton[typeButton] || typesButton.addToBag;
};
/* harmony default export */ __webpack_exports__["default"] = (getTypeButton);

/***/ }),

/***/ 10924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var handleOrigin = function handleOrigin(data) {
  var _data$ads, _data$ads2, _data$ads3;
  return (data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.id) ? "ads:".concat(data == null ? void 0 : (_data$ads2 = data.ads) == null ? void 0 : _data$ads2.id, "|campaignId:").concat(data == null ? void 0 : (_data$ads3 = data.ads) == null ? void 0 : _data$ads3.campaignId) : data == null ? void 0 : data.origin;
};
/* harmony default export */ __webpack_exports__["default"] = (handleOrigin);

/***/ }),

/***/ 90545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildClickCommonEvent": function() { return /* reexport safe */ _buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__["default"]; },
/* harmony export */   "categoryToString": function() { return /* reexport safe */ _categoryToString__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   "channelStoreDimensions": function() { return /* reexport safe */ _channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"]; },
/* harmony export */   "dataLayerPush": function() { return /* reexport safe */ _dataLayerPush__WEBPACK_IMPORTED_MODULE_3__["default"]; },
/* harmony export */   "gaBoolean": function() { return /* reexport safe */ _gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"]; },
/* harmony export */   "gaEcommerceProduct": function() { return /* reexport safe */ _gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_5__["default"]; },
/* harmony export */   "gaSelectedFilters": function() { return /* reexport safe */ _gaSelectedFilters__WEBPACK_IMPORTED_MODULE_6__["default"]; },
/* harmony export */   "getBestPriceDiscount": function() { return /* reexport safe */ _getBestPriceDiscount__WEBPACK_IMPORTED_MODULE_7__["default"]; },
/* harmony export */   "getDiscount": function() { return /* reexport safe */ _getDiscount__WEBPACK_IMPORTED_MODULE_8__["default"]; },
/* harmony export */   "getInstallmentQuantity": function() { return /* reexport safe */ _getInstallmentQuantity__WEBPACK_IMPORTED_MODULE_9__["default"]; },
/* harmony export */   "getSearchTerm": function() { return /* reexport safe */ _getSearchTerm__WEBPACK_IMPORTED_MODULE_10__["default"]; },
/* harmony export */   "getTypeButton": function() { return /* reexport safe */ _getTypeButton__WEBPACK_IMPORTED_MODULE_11__["default"]; },
/* harmony export */   "handleOrigin": function() { return /* reexport safe */ _handleOrigin__WEBPACK_IMPORTED_MODULE_12__["default"]; },
/* harmony export */   "isSomeParametersEmpty": function() { return /* reexport safe */ _isSomeParametersEmpty__WEBPACK_IMPORTED_MODULE_14__["default"]; },
/* harmony export */   "productFormatter": function() { return /* reexport safe */ _productFormatter__WEBPACK_IMPORTED_MODULE_13__["default"]; }
/* harmony export */ });
/* harmony import */ var _buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19777);
/* harmony import */ var _categoryToString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98011);
/* harmony import */ var _channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);
/* harmony import */ var _dataLayerPush__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24169);
/* harmony import */ var _gaBoolean__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20914);
/* harmony import */ var _gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15950);
/* harmony import */ var _gaSelectedFilters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66724);
/* harmony import */ var _getBestPriceDiscount__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82115);
/* harmony import */ var _getDiscount__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54730);
/* harmony import */ var _getInstallmentQuantity__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50734);
/* harmony import */ var _getSearchTerm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6983);
/* harmony import */ var _getTypeButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22078);
/* harmony import */ var _handleOrigin__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10924);
/* harmony import */ var _productFormatter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67412);
/* harmony import */ var _isSomeParametersEmpty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12530);
















/***/ }),

/***/ 12530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var isSomeParametersEmpty = function isSomeParametersEmpty(data) {
  if (data === undefined || data === null) {
    return true;
  }
  var time = data.time,
    complement = data.complement,
    cost = data.cost;
  var restData = {
    complement: complement,
    cost: cost,
    time: time
  };
  var values = Object.values(restData);
  return values.every(function (value) {
    return value === undefined || value === null || value === '';
  });
};
/* harmony default export */ __webpack_exports__["default"] = (isSomeParametersEmpty);

/***/ }),

/***/ 67412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productFormatterOptions": function() { return /* binding */ productFormatterOptions; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95602);

var conditionalToString = function conditionalToString(items) {
  return items ? 'verdadeiro' : 'falso';
};
var slugServicesIds = function slugServicesIds(service) {
  return service ? service == null ? void 0 : service.map(function (item) {
    return String(item == null ? void 0 : item.treeId);
  }).join('|') : 'None';
};
var getMedias = function getMedias(medias) {
  var _medias$videos, _medias$audios, _medias$podcasts;
  var media = [];
  if (medias == null ? void 0 : (_medias$videos = medias.videos) == null ? void 0 : _medias$videos.length) {
    media.push('video');
  }
  if (medias == null ? void 0 : (_medias$audios = medias.audios) == null ? void 0 : _medias$audios.length) {
    media.push('audio');
  }
  if (medias == null ? void 0 : (_medias$podcasts = medias.podcasts) == null ? void 0 : _medias$podcasts.length) {
    media.push('podcasts');
  }
  return media.length ? media.join('|') : 'falso';
};
var productFormatterOptions = {
  frete: function frete(product) {
    var _product$shipping;
    if (!product.shipping || (product == null ? void 0 : (_product$shipping = product.shipping) == null ? void 0 : _product$shipping.length) === 0) return {};
    var _product$shipping$map = product.shipping.map(function (ship) {
        return ship.packages.map(function (pack) {
          var _pack$deliveryTypes, _pack$deliveryTypes2;
          var pickup = pack == null ? void 0 : (_pack$deliveryTypes = pack.deliveryTypes) == null ? void 0 : _pack$deliveryTypes.find(function (val) {
            return val.type === 'store_pickup';
          });
          var conventional = (_pack$deliveryTypes2 = pack.deliveryTypes) == null ? void 0 : _pack$deliveryTypes2.find(function (val) {
            return val.type === 'conventional';
          });
          return {
            days: (conventional == null ? void 0 : conventional.time.toString()) || undefined,
            days_pickup: (pickup == null ? void 0 : pickup.time.toString()) || undefined,
            default_ship: conditionalToString(conventional),
            shipping_value: pack.price,
            store_pickup: conditionalToString(pickup)
          };
        });
      }),
      _product$shipping$map2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_product$shipping$map, 1),
      firstArray = _product$shipping$map2[0];
    return firstArray[0];
  },
  geral: function geral(product) {
    if (Object.keys(product).length > 0) {
      var _product$financialSer, _product$financialSer2, _product$media, _product$media$images;
      var extendedWarranty = (_product$financialSer = product.financialServices) == null ? void 0 : _product$financialSer.find(function (financial) {
        return financial.description === 'Garantia Estendida';
      });
      var robberyAndTheft = (_product$financialSer2 = product.financialServices) == null ? void 0 : _product$financialSer2.find(function (financial) {
        return financial.description === 'Roubo e Furto';
      });
      var media = getMedias(product.media);
      var _ref = product.price || {},
        bestPrice = _ref.bestPrice,
        price = _ref.price;
      var discountPercenter;
      if (bestPrice && price) {
        discountPercenter = 100 * parseFloat(bestPrice) / parseFloat(price);
        discountPercenter = "".concat(Math.abs(discountPercenter - 100).toFixed(2), "%");
      }
      return {
        discountPercenter: discountPercenter,
        images: (_product$media = product.media) == null ? void 0 : (_product$media$images = _product$media.images) == null ? void 0 : _product$media$images.length.toString(),
        media: media,
        theft: robberyAndTheft ? 'verdadeiro' : 'falso',
        warranty: extendedWarranty ? 'verdadeiro' : 'falso'
      };
    }
    return {};
  },
  service: function service(_ref2) {
    var product = _ref2.product,
      services = _ref2.services;
    if (Object.keys(product).length > 0) {
      var _product$media2, _product$media2$image;
      var _ref3 = services || {},
        extendedWarranty = _ref3.extendedWarranty,
        robberyAndTheft = _ref3.robberyAndTheft;
      var media = getMedias(product.media);
      var _ref4 = product.price || {},
        bestPrice = _ref4.bestPrice,
        price = _ref4.price;
      var discountPercenter;
      if (bestPrice && price) {
        discountPercenter = 100 * parseFloat(bestPrice) / parseFloat(price);
        discountPercenter = "".concat(Math.abs(discountPercenter - 100).toFixed(2), "%");
      }
      return {
        discountPercenter: discountPercenter,
        images: (_product$media2 = product.media) == null ? void 0 : (_product$media2$image = _product$media2.images) == null ? void 0 : _product$media2$image.length.toString(),
        media: media,
        theft: slugServicesIds(robberyAndTheft),
        warranty: slugServicesIds(extendedWarranty)
      };
    }
    return {};
  }
};
var productFormatter = function productFormatter(items, option) {
  if (option) {
    var selectedOption = productFormatterOptions[option];
    return selectedOption(items);
  }
  return {};
};
/* harmony default export */ __webpack_exports__["default"] = (productFormatter);

/***/ })

}]);